import React, { memo, useState } from 'react';
import styles from './AppCard.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { getAppsList } from '../../../../actions/order';
import { debounce } from 'lodash-es';
import Config from '../../config';
import Toast from '../../../../components/Toast/Toast';
import { logging, logPostInfo } from '../../../../actions/log';
import { createSelector } from 'reselect';
import Default from '../../../../static/order_default_app_icon.svg';
import Dialog from '../../../../components/Dialog/Dialog';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const lineInfo = [
  { id: 1, name: 'tradeNo', cnName: '订单号', info: '' },
  { id: 2, name: 'appName', cnName: '购买途径', info: '' },
  { id: 3, name: 'payTime', cnName: '支付时间', info: '' },
  { id: 4, name: 'tradeStatusMsg', cnName: '订单状态', info: '' },
  { id: 5, name: 'buyWay', cnName: '权益范围', info: '' },
];

export default memo(({ info }) => {
  const dispatch = useDispatch();
  const [validImg, setValidImg] = useState(info.appIcon);
  const [showReason, setShowReason] = useState(false);
  const logInfoData = useSelector(selectLogInfo);
  const [visible, setVisible] = useState(false);

  const refund = debounce(async () => {
    if (info?.userType === 0) {
      let data = await Config.orderRefund({ tradeNo: info.tradeNo, refundAmount: info.payAmount });
      if (data) {
        Toast.success({ content: '提交退款成功' });
        dispatch(
          getAppsList({
            deviceId: sessionStorage.getItem('APP_ORDER_ID'),
            page: 1,
            size: 24,
            refresh: true,
          }),
        );
      } else {
        Toast.error({ content: '提交退款失败' });
      }
    } else if (info?.userType === 3) {
      let data = await Config.orderDeviceRefund({
        deviceId: sessionStorage.getItem('APP_ORDER_ID'),
        tradeNo: info.tradeNo,
        refundAmount: info.payAmount,
      });
      if (data) {
        Toast.success({ content: '提交退款成功' });
        dispatch(
          getAppsList({
            deviceId: sessionStorage.getItem('APP_ORDER_ID'),
            page: 1,
            size: 24,
            refresh: true,
          }),
        );
      } else {
        Toast.error({ content: '提交退款失败' });
      }
    }

    setVisible(false);
    dispatch(
      logging({
        category: 'C',
        action: 'Store_Refund',
        label: '',
        param2: {
          source: 'App_Equity',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          id: info.tradeNo,
        },
      }),
    );
  }, 500);

  const handleCancelModal = tag => {
    setVisible(false);
    if (tag) {
      dispatch(
        logging({
          category: 'C',
          action: 'Store_Refund_Cancel',
          label: '',
          param2: {
            source: 'App_Equity',
            source_p: logInfoData.source,
            source_pp: logInfoData.source_p,
            id: info.tradeNo,
          },
        }),
      );
    }
  };

  const handleOpenRefund = () => {
    setVisible(true);
    dispatch(
      logging({
        category: 'P',
        action: 'Store_Refund',
        label: '',
        param2: {
          source: 'App_Equity',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          id: info.tradeNo,
        },
      }),
    );
  };

  return (
    <div className={styles.mall_orders_card}>
      <div className={styles.card_header}>
        <div className={styles.card_name}>
          <div className={styles.name_icon}>
            <img src={validImg ?? Default} onError={() => setValidImg(Default)} />
          </div>
          <div className={styles.mall_name}>
            <div className={styles.name} title={info.goodsName}>
              {info.goodsName}
            </div>
            {info.refundable === 0 && info.tradeStatus !== 2 && (
              <div className={styles.no_reason}>7天无理由退换</div>
            )}
          </div>
        </div>
        <div className={styles.card_btn}>
          {/* <div onClick={handleOpenRefund} className={styles.btn}>
            退款
          </div> */}
          {info.refundable === 0 && info.tradeStatus === 1 && (
            <div onClick={handleOpenRefund} className={styles.btn}>
              退款
            </div>
          )}
          {info.refundable === 1 && info.tradeStatus === 1 && info.refundableMsg && (
            <div className={styles.sigh}>
              <i
                className="iconfont icon-toolbar_about"
                onMouseEnter={() => setShowReason(true)}
                onMouseLeave={() => setShowReason(false)}
              />
              {showReason && (
                <div className={styles.sigh_reason}>
                  <div className={styles.reason_info}>{info.refundableMsg}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className={styles.card_info}>
        {lineInfo.map(el => {
          if (el.id === 5) {
            if (info?.userType === 3) {
              return (
                <div key={el.id} className={styles.info_item_content_desc}>
                  <div className={styles.info_item_name_desc}>{el.cnName}</div>
                  <div className={styles.info_item_content}>{'当前该设备可享受该权益'}</div>
                </div>
              );
            }
            if (info?.userType === 0) {
              return (
                <div key={el.id} className={styles.info_item_content_desc}>
                  <div className={styles.info_item_name_desc}>{el.cnName}</div>
                  <div className={styles.info_item_content}>{info?.equity}</div>
                </div>
              );
            }
          } else {
            return (
              <div key={el.id} className={styles.card_info_item}>
                <div className={styles.info_item_name}>{el.cnName}</div>
                <div className={styles.info_item_content}>{info[el.name]}</div>
              </div>
            );
          }
        })}
      </div>
      {visible && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          handleClose={handleCancelModal}
          title="温馨提示"
        >
          <div className={styles.modal_content}>
            退款成功后，您将失去该应用内的会员权益，确认申请退款吗？
          </div>
          <div className={styles.modal_button}>
            <div className={styles.button} onClick={() => handleCancelModal(1)}>
              取消
            </div>
            <div className={styles.button_sub} onClick={refund}>
              确认退款
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
});
